import { useSelector } from 'react-redux';
import style from './SubtitleTorrents.module.scss'
import { selectMovie } from '../../../../../redux/movieSlices/MovieSelector'

type Torrents = {
    quality: number;
    type: number;
    size: number;
    peers: number;
    seeds: number;
    url: string;
}

let SubtitleTorrents = () => {

    const { movie } = useSelector(selectMovie)

    return (
        <div className={style.subtitle__torrents}>
            <span>Torrents</span>
            {movie.torrents.map((el) => <div className={style.torrents__block}><span>Quality: {el.quality}</span>
                <span>Type: {el.type}</span><span>Size: {el.size}</span>
                <span>P/S: {el.peers}/{el.seeds}</span><a href={el.url}><button className={style.torrents__button}>Download</button></a></div>)}
        </div>
    )
}

export default SubtitleTorrents;